import * as React from 'react';
import { NextRouterTracking } from 'auto-tracking';
import { PageView as PageViewType } from 'common-tracking';
import { NextRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { useAuthContext } from 'sso';

type Publisher = {
  slug: string;
};

export const PageView = ({
  pageProps,
}: {
  pageProps: {
    journal?: { gatherAnalytics: boolean; slug: string; publisher: Publisher };
  };
}) => {
  const { authState } = useAuthContext();
  const [flowType, setFlowType] = useState('other_journey');

  const additionalProperty = useCallback(
    (router: NextRouter) => {
      let flow = flowType;
      if (router.pathname.indexOf('submit') > -1) {
        setFlowType('submission_journey');
        flow = 'submission_journey';
      }
      const returnData: Partial<PageViewType> = {
        journalName: pageProps.journal?.slug ?? '',
        publisherName: pageProps.journal?.publisher.slug ?? '',
        flowType: flow,
        anonymousOrSignedIn:
          authState.name === 'logged in' ? 'signed_in' : 'anonymous',
      };
      return returnData;
    },
    [authState, flowType, setFlowType, pageProps],
  );
  return (
    <>
      <NextRouterTracking getAdditionalProperty={additionalProperty} />
    </>
  );
};
